import globalDomains from '@/utils/global-domains';
import {useEffect, useRef, useState} from 'react';

const usePlayer = () => {
  const [isOpenPlayer, setIsOpenPlayer] = useState(false);
  const [player, setPlayer] = useState({
    id: null,
    title: null,
  });
  const playerRef = useRef(null);

  const openPlayer = () => {
    setIsOpenPlayer(true);
  };

  const closePlayer = () => {
    setIsOpenPlayer(false);
  };

  const handleLoadPlayer = (id, title = '') => {
    if (id) {
      setPlayer({
        id: id,
        title: title,
      });
    }
  };

  useEffect(() => {
    const existingScript = document.getElementById('embed-script');
    const container = document.getElementById('savyg_player');
    if (!container) {
      return;
    }
    const initPlayer = () => {
      playerRef.current = new AF.Player('savyg_player', {
        mutePlay: false,
        showChat: false,
        isAdShow: false,
        autoPlay: true,
        showQualityBox: false,
        fromApi: 1,
        isRecommendShow: false,
        isEndRecommendShow: false,
        apiKey: '321227c',
      });

      if (playerRef.current) {
        playerRef.current.loadVideo({
          videoId: player.id,
        });
      }
    };
    if (!existingScript) {
      const script = document.createElement('script');
      script.id = 'embed-script';
      script.src = `${globalDomains.STATIC_AFREECATV}/asset/app/embed/embed.min.js`;
      document.head.appendChild(script);
      window.onAFIframeAPIReady = initPlayer;
    } else {
      // 이미 스크립트가 있다면 onAFIframeAPIReady는 안 불리니까 직접 실행
      if (window.AF) {
        if (!playerRef.current) {
          initPlayer();
        } else {
          playerRef.current.loadVideo({videoId: player.id});
        }
      } else {
        console.warn('AF Player 스크립트는 있지만 아직 로드되지 않음');
      }
    }
  }, [isOpenPlayer, player]);

  return {player, isOpenPlayer, openPlayer, closePlayer, handleLoadPlayer};
};

export default usePlayer;
